import { Controller } from 'react-hook-form';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import BaseInput from '../BaseInput';

export interface QuillInputProps extends IQuillField {
  disable?: boolean;
}

export default function QuillInput(props: QuillInputProps) {
  const { name, placeholder, disable, ...rest } = props;

  return (
    <BaseInput name={name} {...rest}>
      {({ control }) => (
        <Controller
          control={control}
          name={name}
          render={({ field: { onChange, value, ref } }) => (
            <ReactQuill
              onChange={onChange}
              value={value || ''}
              ref={ref}
              theme="snow"
              placeholder="Write your article content here..."
              id="body"
            />
          )}
        />
      )}
    </BaseInput>
  );
}
